import { render } from "./KoursesAddToMembership.vue?vue&type=template&id=5f012349"
import script from "./KoursesAddToMembership.vue?vue&type=script&lang=js"
export * from "./KoursesAddToMembership.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__